import { FaLocationDot, FaLocationPin } from 'react-icons/fa6';
import './Features.css';
import { FaFileInvoiceDollar, FaUsers, FaHandshake, FaBoxes, FaChartLine, FaShieldAlt } from 'react-icons/fa';

const featuresData = [
  {
    icon: <FaLocationDot />,
    title: 'Real-time Location Tracking',
    description: 'Optimiz offers real-time location tracking to monitor employee movements during work hours.'
  },
  {
    icon: <FaUsers />,
    title: 'Employee Performance',
    description: 'Monitor employee productivity and performance with our advanced analytics tools.'
  },
  {
    icon: <FaHandshake />,
    title: 'Dealer Empowerment',
    description: 'Provide your dealers with the tools they need to succeed and grow their business.'
  },
  {
    icon: <FaBoxes />,
    title: 'Inventory Tracking',
    description: 'Keep track of your stock levels in real-time, across multiple locations.'
  },
  {
    icon: <FaChartLine />,
    title: 'Reporting & Analytics',
    description: 'Gain valuable insights into your business with our comprehensive reporting suite.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Secure & Reliable',
    description: 'Your data is safe with us. We use industry-leading security measures to protect it.'
  }
];

const Features = () => {
  return (
    <section id="features" className="features-section">
      <div className="container">
        <div className="section-heading">
          <h1>Powerful features to run your business</h1>
          <p>Everything you need to streamline your operations, from invoicing to employee management, all in one place.</p>
        </div>
        <div className="features-grid">
          {featuresData.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
